var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var _a, _b, _c;
import { Line } from "vue-chartjs";
import { Vue, Component, Prop, Watch } from "vue-facing-decorator";
import "chartjs-plugin-zoom";
import "chartjs-plugin-annotation";
import "chart.js";
import { TimeseriesChart } from "@/app/api/battery-portal-api";
import { DateHelper } from "@/app/utils/date-helper";
import { MeasurementHelper } from "@/app/utils/measurement-helper";
import { _adapters } from 'chart.js';
import { Chart as ChartJS, CategoryScale, PointElement, LineElement, Title, Tooltip, Legend, TimeScale, LinearScale } from 'chart.js';
import zoomPlugin from 'chartjs-plugin-zoom';
import annotationPlugin from 'chartjs-plugin-annotation';
ChartJS.register(CategoryScale, LinearScale, TimeScale, PointElement, LineElement, Title, Tooltip, Legend, zoomPlugin, annotationPlugin);
_adapters._date.override(DateHelper.getChartJSDateAdapter());
const maxTicks = 10;
const minStepSize = 1e-14;
let TrendGraph = class TrendGraph extends Vue {
    constructor() {
        super(...arguments);
        this.canPlot = false;
    }
    optionsChanged() {
    }
    ;
    mounted() {
        try {
            this.plot();
        }
        catch (ex) {
            console.error(ex);
        }
    }
    ;
    resetZoom() {
        if (!this.chartInstance.resetZoom)
            return;
        this.chartInstance.resetZoom();
    }
    ;
    plot() {
        var _a;
        if (!this.chartData)
            return;
        this.renderOptions = Object.assign({}, this.options);
        this.renderData = JSON.parse(JSON.stringify(this.chartData));
        //console.log('renderData', JSON.stringify(this.renderData));
        //console.log('renderOptions', JSON.stringify(this.renderOptions));
        if (this.hasAnnotations) {
            this.renderOptions.plugins['annotation'] = {
                annotations: JSON.parse(JSON.stringify(this.chartData.annotations))
            };
        }
        this.renderOptions.onClick = (event, elements) => {
            const chart = this.$refs.trendLineChart.chart;
            let points = chart.getElementsAtEventForMode(event, "nearest", {
                intersect: false
            });
            if (points && points.length > 0) {
                var datasetIndex = points[0].datasetIndex;
                this.$emit("datasetIdSelected", datasetIndex, event.native.ctrlKey);
            }
        };
        this.setScalePreferences(this.renderOptions, false);
        // set default animation preferences. further chagnes are applied via @Watch
        this.renderOptions.animation = { duration: this.animate ? 1000 : 0 };
        // Performance optimizations for large datasets
        const totalDataPoints = ((_a = this.renderData.datasets) === null || _a === void 0 ? void 0 : _a.reduce((sum, ds) => { var _a; return sum + (((_a = ds.data) === null || _a === void 0 ? void 0 : _a.length) || 0); }, 0)) || 0;
        if (totalDataPoints > 1000) {
            // Disable animations for large datasets
            this.renderOptions.animation = false;
        }
        this.canPlot = this.renderData.datasets && this.renderData.datasets.length > 0;
    }
    ;
    update() {
        this.chartInstance.update();
        this.$emit("chartUpdated");
    }
    ;
    hideAnnotations() {
        this.chartInstance.options.plugins.annotation = {};
        this.update();
    }
    ;
    setScalePreferences(options, updateChart) {
        var _a;
        if (!options.scales)
            return;
        let minValue = 0;
        let maxValue = 0;
        if (this.chartData.minValue != undefined)
            minValue = this.chartData.minValue;
        if (this.chartData.maxValue != undefined)
            maxValue = this.chartData.maxValue;
        var yScalesArray = [];
        for (const key in options.scales) {
            if (key.startsWith('y')) {
                yScalesArray.push(options.scales[key]);
            }
        }
        // set default ticks.
        for (let i = 0; i < yScalesArray.length; i++) {
            let scale = yScalesArray[i];
            scale.ticks = {};
            scale.ticks.callback = this.tickCallback;
        }
        if (this.autoScale) {
            for (let i = 0; i < yScalesArray.length; i++) {
                let scale = yScalesArray[i];
                let range = (_a = this.chartData.ranges) === null || _a === void 0 ? void 0 : _a.filter(match => match.axisId == scale.id)[0];
                scale.min = undefined;
                scale.max = undefined;
                scale.suggestedMin = undefined;
                scale.suggestedMax = undefined;
                if (!this.syncAxes) {
                    scale.suggestedMin = (range === null || range === void 0 ? void 0 : range.minValue) || 0;
                    scale.suggestedMax = (range === null || range === void 0 ? void 0 : range.maxValue) || 0;
                }
                else {
                    scale.min = minValue;
                    scale.suggestedMax = maxValue;
                }
            }
        }
        else {
            for (let i = 0; i < yScalesArray.length; i++) {
                let scale = yScalesArray[i];
                let range = this.scaleRanges.filter(match => match.scaleId == scale.id)[0];
                if (!this.syncAxes) {
                    scale.min = Number(range === null || range === void 0 ? void 0 : range.minValue) || 0;
                    scale.max = Number(range === null || range === void 0 ? void 0 : range.maxValue) || 0;
                }
                else {
                    scale.min = Math.min(...this.scaleRanges.map(item => item.minValue)) || 0;
                    scale.max = Math.max(...this.scaleRanges.map(item => item.maxValue)) || 0;
                }
            }
        }
        for (let i = 0; i < yScalesArray.length; i++) {
            let scale = yScalesArray[i];
            let min = scale.min || scale.suggestedMin;
            let max = scale.max || scale.suggestedMax;
            let stepSize = this.getStepSize(min, max, maxTicks);
            if (stepSize > minStepSize)
                scale.stepSize = stepSize;
        }
        //this.setZoomPreferences(options);
        //if (this.chartInstance)
        //	this.chartInstance.options.scales.yAxes = options.scales.yAxes;
        if (!updateChart)
            return;
        this.update();
    }
    ;
    //setZoomPreferences(options: any) {
    //	if (!options.plugins?.zoom) return;
    //	options.plugins.zoom.zoom.onZoomComplete = this.zoomCallback;
    //	try {
    //		let dates = this.chartData.labels || [];
    //		if (!dates.length) return;
    //		let minX = dates[0];
    //		let maxX = dates[dates.length - 1];
    //		let minDate = DateHelper.convertToDate(minX);
    //		let maxDate = DateHelper.convertToDate(maxX);
    //		switch (this.chartData.displayUnit) {
    //			case "minute":
    //				minDate = moment(minDate.toISOString()).add(-120, "minutes").toDate();
    //				maxDate = moment(maxDate.toISOString()).add(120, "minutes").toDate();
    //				break;
    //			case "hour":
    //				minDate = moment(minDate.toISOString()).add(-48, "hours").toDate();
    //				maxDate = moment(maxDate.toISOString()).add(48, "hours").toDate();
    //				break;
    //			case "day": ;
    //				minDate = moment(minDate.toISOString()).add(-10, "days").toDate();
    //				maxDate = moment(maxDate.toISOString()).add(10, "days").toDate();
    //		}
    //		if (minDate != new Date()
    //			&& maxDate != new Date()
    //			&& options.plugins.zoom) {
    //			options.plugins.zoom.limits = {
    //				'x-axis-0': {}
    //			};
    //			options.plugins.zoom.limits['x-axis-0'].min = minDate;
    //			options.plugins.zoom.limits['x-axis-0'].max = maxDate;
    //		}
    //	}
    //	catch (ex) {
    //		console.error(`pan: ${ex}`);
    //	}
    //};
    //@Watch("animate")
    //setAnimationPreferences() {
    //	let chart = this.chartInstance;
    //	if (!chart) return;
    //	chart.options.animation.duration = this.animate ? 1000 : 0;
    //};
    tickCallback(value) {
        return Number.isInteger(value) ? `${value}` : `${parseFloat(value.toFixed(3).toString())}`;
    }
    ;
    zoomCallback(chartObject) {
        try {
            // Unecessary code???
            //let options: any = { ...this.options };
            //console.log('chartObject', chartObject);
            //var yScalesArray = [];
            //for (const key in options.scales) {
            //	if (key.startsWith('y')) {
            //		yScalesArray.push(options.scales[key]);
            //	}
            //}
            //let update = false;
            //yScalesArray.forEach(chartScale => {
            //	//let chartScale = chartObject.chart.scales[scale.id];
            //	let ticks: Array<number> = chartScale.ticks || [];
            //	if (ticks.length) {
            //		let stepSize = chartScale.stepSize;
            //		if (!stepSize) return;
            //		let tickHeight = stepSize / ticks.length;
            //		let firstTickDifference = Math.abs(ticks[0] - ticks[1]);
            //		let lastTickDifference = Math.abs(ticks[ticks.length - 2] - ticks[ticks.length - 1]);
            //		if (firstTickDifference <= tickHeight) {
            //			chartScale.max = ticks[0] + tickHeight * 2;
            //			update = true;
            //		}
            //		if (lastTickDifference <= tickHeight) {
            //			chartScale.min = ticks[ticks.length - 1] - tickHeight * 2;
            //			update = true;
            //		}
            //		if (update) {
            //			let stepSize = this.getStepSize(chartScale.min, chartScale.max, maxTicks);
            //			if (stepSize > minStepSize)
            //				chartScale.stepSize = stepSize;
            //			scale.ticks.min = chartScale.min;
            //			scale.ticks.max = chartScale.max;
            //			scale.ticks.stepSize = chartScale.stepSize;
            //		}
            //	}
            //});
            // Old
            //let update = false;
            //for (let i = 0; i < options.scales.yAxes.length; i++) {
            //	let scale = options.scales.yAxes[i];
            //	if (!scale) return;
            //	let chartScale = chartObject.chart.scales[scale.id];
            //	let ticks: Array<number> = chartScale.ticksAsNumbers || [];
            //	if (!ticks.length || ticks.length <= 1) continue;
            //	let stepSize = chartScale.options.stepSize;
            //	if (!stepSize) return;
            //	let tickHeight = stepSize / ticks.length;
            //	let firstTickDifference = Math.abs(ticks[0] - ticks[1]);
            //	let lastTickDifference = Math.abs(ticks[ticks.length - 2] - ticks[ticks.length - 1]);
            //	if (firstTickDifference <= tickHeight) {
            //		chartScale.max = ticks[0] + tickHeight * 2;
            //		update = true;
            //	}
            //	if (lastTickDifference <= tickHeight) {
            //		chartScale.min = ticks[ticks.length - 1] - tickHeight * 2;
            //		update = true;
            //	}
            //	if (update) {
            //		let stepSize = this.getStepSize(chartScale.min, chartScale.max, maxTicks);
            //		if (stepSize > minStepSize)
            //			chartScale.stepSize = stepSize;
            //		scale.ticks.min = chartScale.min;
            //		scale.ticks.max = chartScale.max;
            //		scale.ticks.stepSize = chartScale.stepSize;
            //	}
            //}
            //if (!update) return;
            //this.chartInstance.options.scales.yAxes = options.scales.yAxes;
            //this.update();
        }
        catch (ex) {
            console.error(`zoom: ${ex}`);
        }
    }
    ;
    getStepSize(min, max, maxTicks) {
        let stepSize = MeasurementHelper.getNiceNumber((max - min) / maxTicks, 0);
        if (stepSize <= minStepSize)
            return 0.05;
        let tickCount = Math.ceil(max / stepSize) - Math.floor(min / stepSize);
        if (tickCount > maxTicks)
            stepSize = MeasurementHelper.getNiceNumber(tickCount * stepSize / maxTicks, 0);
        stepSize = stepSize || 1;
        return stepSize;
    }
    get hasAnnotations() {
        return this.chartData && this.chartData.annotations ? true : false;
    }
    ;
    get chartInstance() {
        return this.$refs.trendLineChart.chart;
    }
    ;
};
__decorate([
    Prop(),
    __metadata("design:type", typeof (_a = typeof TimeseriesChart !== "undefined" && TimeseriesChart) === "function" ? _a : Object)
], TrendGraph.prototype, "chartData", void 0);
__decorate([
    Prop(),
    __metadata("design:type", typeof (_b = typeof Object !== "undefined" && Object) === "function" ? _b : Object)
], TrendGraph.prototype, "options", void 0);
__decorate([
    Prop(),
    __metadata("design:type", Boolean)
], TrendGraph.prototype, "animate", void 0);
__decorate([
    Prop(),
    __metadata("design:type", Boolean)
], TrendGraph.prototype, "autoScale", void 0);
__decorate([
    Prop(),
    __metadata("design:type", Boolean)
], TrendGraph.prototype, "syncAxes", void 0);
__decorate([
    Prop(),
    __metadata("design:type", typeof (_c = typeof Array !== "undefined" && Array) === "function" ? _c : Object)
], TrendGraph.prototype, "scaleRanges", void 0);
__decorate([
    Prop(),
    __metadata("design:type", String)
], TrendGraph.prototype, "styles", void 0);
__decorate([
    Watch("options"),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", void 0)
], TrendGraph.prototype, "optionsChanged", null);
TrendGraph = __decorate([
    Component({
        emits: ['datasetIdSelected', 'chartUpdated'],
        expose: ['resetZoom', 'hideAnnotations', 'chartInstance'],
        components: {
            Line
        }
    })
], TrendGraph);
export default TrendGraph;
